var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "15px",
            color: "#1a1a1a",
            "font-weight": "600",
            "text-align": "center",
            padding: "15px 0"
          }
        },
        [_vm._v("调拨单信息")]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.stuffTransVoucher.no))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.stuffTransVoucher.srcVoucherNo || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.stuffTransVoucher.outerNo || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建机构")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.stuffTransVoucher.creatorComName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("调出机构")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.stuffTransVoucher.srcBizUnitName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("调入机构")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.stuffTransVoucher.dstBizUnitName))]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.stuffTransVoucher.createTime))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建人")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.stuffTransVoucher.creatorName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("审核公司")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.stuffTransVoucher.auditComName || "无")
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("审核人")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.stuffTransVoucher.auditorName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("确认人")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.stuffTransVoucher.confirmerName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("申请描述")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.stuffTransVoucher.applyDesc || "无")
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("审核原因")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.stuffTransVoucher.auditDesc || "无")
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("确认描述")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.stuffTransVoucher.confirmDesc || "无")
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "60px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("备注")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.stuffTransVoucher.memo || "无"))]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.stuffTransVoucher.itemList, function(item) {
        return _c(
          "div",
          {
            staticStyle: {
              overflow: "hidden",
              border: "1px solid rgb(26, 26, 26)",
              "margin-top": "10px"
            }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(4, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_vm._v(_vm._s(item.tmpNo))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(5, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_vm._v(_vm._s(item.title))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(6, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(item.name))])]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(7, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_vm._v(_vm._s(item.model || ""))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(8, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_vm._v(_vm._s(item.fixedSpec || ""))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(9, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(item.catName))])]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(10, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getDevcGroupNameByCatId(item.catId)))
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(11, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_vm._v(_vm._s(item.brandName))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(12, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(item.srcComName))])]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(13, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(item.srcWarehouseName))])]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(14, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(item.dstComName))])]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(15, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(item.dstWarehouseName))])]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(16, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(item.quantity - item.quantity2))])]
                )
              ]
            ),
            _vm._v(" "),
            _vm.stuffTransVoucher.assetType != 2
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      overflow: "hidden",
                      width: "33.33%",
                      float: "left",
                      "margin-top": "5px",
                      "font-size": "12px"
                    }
                  },
                  [
                    _vm._m(17, true),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "54px",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "word-wrap": "break-word",
                          color: "#666666"
                        }
                      },
                      [_vm._v(_vm._s(item.quantity2 || 0))]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "33.33%",
                  float: "left",
                  "margin-top": "5px",
                  "font-size": "12px"
                }
              },
              [
                _vm._m(18, true),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "54px",
                      "white-space": "normal",
                      "word-break": "break-all",
                      "word-wrap": "break-word",
                      color: "#666666"
                    }
                  },
                  [_vm._v(_vm._s(item.memo))]
                )
              ]
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("基本信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "60px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("调拨单号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "60px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("来源单据号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "60px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("外部单据号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("系统编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("资产描述全称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("型号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("规格")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("分类")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("分类分组")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("品牌")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调出部门")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调出仓库")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入部门")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入仓库")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调拨可用数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调拨报废/弃用数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "60px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("备注")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1683bc66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1683bc66","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/tranVoucherDevc/StuffTransVoucherForPdf.vue
// module id = 2580
// module chunks = 0